import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LogoutIcon from '@mui/icons-material/Logout';
import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded';
import { MenuItem, useTheme } from '@mui/material';
import Link from 'next/link';

import HamburgerMenu from 'src/components/hamburger-menu';

import { logout } from 'src/services/auth-service/logout.service';
import { CART_ID_COOKIE_KEY } from 'src/utils/constants';
import JsCookie from 'js-cookie';
import { useRouter } from 'next/router';
import useNonNullContext from 'src/hooks/useNonNullContext';
import UserContext from 'src/context/user';

const AccountMenu = () => {
  const theme = useTheme();
  const router = useRouter();
  const { setUser } = useNonNullContext(UserContext);

  const handleLogout = async () => {
    await logout();
    JsCookie.remove(CART_ID_COOKIE_KEY);
    await router.push('/login');
    setUser(null);
  };

  const iconSx = {
    height: 32,
    width: 32,
    marginRight: '0.5rem',
    color: theme.palette.grey[500],
  };

  return (
    <HamburgerMenu>
      <MenuItem>
        <Link
          href="/my-account"
          style={{
            textDecoration: 'none',
            color: 'inherit',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <AccountCircleIcon sx={iconSx} />
          Account Info
        </Link>
      </MenuItem>
      <MenuItem>
        <Link
          href="/my-credits"
          style={{
            textDecoration: 'none',
            color: 'inherit',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <AccountBalanceWalletRoundedIcon sx={iconSx} />
          My Credits
        </Link>
      </MenuItem>
      <MenuItem>
        <Link
          href="/my-reviews"
          style={{
            textDecoration: 'none',
            color: 'inherit',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <StarRateRoundedIcon sx={iconSx} />
          My Reviews
        </Link>
      </MenuItem>
      <MenuItem>
        <Link
          href="/payment-history"
          style={{
            textDecoration: 'none',
            color: 'inherit',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <ReceiptIcon sx={iconSx} />
          Order History
        </Link>
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <LogoutIcon sx={iconSx} />
        Sign Out
      </MenuItem>
    </HamburgerMenu>
  );
};

export default AccountMenu;
